/** Iniciais para avatar.
 *
 * Módulo separado do componente de propósito: um arquivo que exporta função e
 * componente ao mesmo tempo desliga o Fast Refresh do Vite, e a régua fica
 * lenta justamente nas telas em que se mexe mais.
 */

/** Duas letras no máximo: três já não cabem no círculo e viram borrão. */
export function iniciais(nome: string): string {
  const partes = nome.trim().split(/\s+/).filter(Boolean);
  if (partes.length === 0) return "?";
  const primeira = partes[0]?.[0] ?? "";
  const ultima = partes.length > 1 ? (partes.at(-1)?.[0] ?? "") : "";
  return (primeira + ultima).toUpperCase();
}

export function inicial(nome: string): string {
  return (nome.trim()[0] ?? "?").toUpperCase();
}

export function primeiroNome(nome: string): string {
  return nome.trim().split(/\s+/)[0] ?? nome;
}
